<template>
  <div class="plan-card">
    <div
      class="plan-header"
      :style="{background: plan.background}">
      <div class="title">{{ plan.fakePlanName }}</div>
      <div
        class="price"
        :style="{color: plan.priceColor}">
        <span class="price-num">${{ plan.price }}</span>/hour
      </div>
    </div>
    <div class="plan-container">
      <div class="input addon-item">
        <div class="name">Number of live sources</div>
        <div class="info">
          <div
            class="nums"
            :style="{color: plan.color}">{{ plan.input }}</div>
          <div class="support">Support <span>TVU Anywhere</span>/<span>TVU One</span>/TVU Grid/TVU Partyline/EXT IP Source/HTML/RTMP Push/Local video</div>
        </div>
      </div>
      <div class="output addon-item">
        <div class="name">Number of outputs</div>
        <div class="info">
          <div
            class="nums"
            :style="{color: plan.color}">
            <el-input
              v-model="outputNumber"
              type="number"
              @input="handleInput"></el-input>
          </div>
          <!-- <div class="support">Support TVU Grid/<span>ProMPEG</span>/<span>ISSP</span>/HLS/SRT/Social account/Protocol (File/RTMP(S)/UDP/RTSP)</div> -->
          <div class="support">Support TVU Channel/ <span>TVU Grid/</span> HLS/ ISSP/ RTP-FEC/ SRT/ Zixi/ RTMP(S)/ UDP/ RTSP/ Facebook/ Instagram/ Yi Live/ Twitter/ Twitch/ Kuaishou/ Vimeo/ Others</div>

        </div>
      </div>
      <div class="storage addon-item">
        <div class="name">Storage</div>
        <div class="info">500 GB</div>
      </div>
      <!-- <div class="record addon-item">
        <div class="name">Recording</div>
        <div class="info">All slots</div>
      </div>
      <div class="replay addon-item">
        <div class="name">Replay</div>
        <div class="info"><i class="el-icon-check"></i></div>
      </div> -->
    </div>
    <div class="plan-footer">
      <div
        class="choose"
        :class="{'no-drop': !outputNumber, 'no-choose':hasExist }"
        @click="handleClickChoose">Choose this plan</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    plan: Object,
    existPlan: Object || null
  },
  data () {
    return {
      outputNumber: 1,
      lastOutputNumber: 1,
      initOutputNumber: 1
    }
  },
  created () {
    if (this.existPlan) {
      const chargeItems = this.existPlan.chargeItems
      const { Output } = this.handleAddOn(chargeItems)
      // 找到当前的的sub
      this.initOutputNumber = Output.quantity
      this.outputNumber = Output.quantity
      this.lastOutputNumber = Output.quantity
    } else {
      this.initOutputNumber = this.plan.output
      this.outputNumber = this.plan.output
      this.lastOutputNumber = this.plan.output
    }
  },
  methods: {
    handleAddOn (chargeItems) {
      let InputNumber = {}
      let TimeCredit = {}
      let Output = {}
      chargeItems.forEach(i => {
        if (i.addonId == 'producer-input-number') {
          InputNumber = i
        } else if (i.addonId == 'producer-time-credit') {
          TimeCredit = i
        } else if (i.addonId == 'producer-additional-output') {
          Output = i
        }
      })

      return { InputNumber, TimeCredit, Output }
    },
    handleClickChoose () {
      if (this.hasExist || !this.outputNumber) return false
      const chargeItem = {
        [this.plan.Number]: this.plan.input,
        [this.plan.Credit]: 0,
        [this.plan.Output]: Number(this.outputNumber)
      }
      if (this.existPlan) {
        // 展示Convert按钮
        this.$emit('planchoose', {
          type: 'convertPlan',
          chargeItem
        })
      } else {
        // 去支付
        this.$emit('planchoose', {
          type: 'newPlan',
          id: this.plan.id,
          chargeItem
        })
      }
    },
    handleChoose () {
      if (this.hasExist || !this.outputNumber) return false
      this.$emit('planchoose', this.plan.id)
    },
    handleInput (value) {
      if (!value) return
      const input = Number(value)
      if (input > 10000) {
        this.outputNumber = this.lastOutputNumber
      } else if (!Number.isInteger(input) || input < this.initOutputNumber) {
        // 判断整数
        this.outputNumber = this.lastOutputNumber
      } else {
        this.lastOutputNumber = input
      }
    }
  },
  computed: {
    style () {
      return this.plan.style || {}
    },
    hasExist () {
      if (!this.existPlan) return false
      const chargeItems = this.existPlan.chargeItems
      const chargeItem = chargeItems.find(i => i.addonId == 'producer-input-number')
      return chargeItem.quantity == this.plan.input
    }
  }
}
</script>

<style lang="less" scoped>
.plan-card {
  width: 400px;
  text-align: left;
  border-radius: 10px;
  margin: 0 15px;
  box-shadow: 0 10px 20px #0003;
  overflow: hidden;
  background-color: var(--plan-card-bg);
  .plan-header {
    background: linear-gradient(274.86deg, #BDCFF4 0%, #E6EDFA 100%);
    // height: 134px;
    padding:30px 0 20px;
    .title {
      font-weight: 500;
      font-size: 24px;
      line-height: 16px;
      text-align: center;
      color: #000000;
      margin-bottom: 20px;
    }
    .price {
      margin: 0;
      font-size: 24px;
      line-height: 24px;
      font-weight: normal;
      .price-num {
        font-weight: 700;
        font-size: 32px;
        line-height: 38px;
      }
    }
  }

  .plan-container {
    margin: 30px 0;
    .addon-item {
      display: flex;
      margin: 20px 0;
      padding: 0 15px;
      color: var(--dialog-text-color);
      .name {
        width: 50%;
        text-indent: 30px;
      }
      .info {
        width: 50%;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
        color: var(--dialog-text-info-color);
        .support {
          font-weight: 400;
          font-size: 14px;
          line-height: 14px;
          color: #888888;
          word-break: break-word;
        }
      }
    }

    // ::v-deep .el-input {
    //   input[type="number"]::-webkit-inner-spin-button,
    //   input[type="number"]::-webkit-outer-spin-button {
    //     -webkit-appearance: none;
    //     margin: 0; /* Removes the default margin */
    //     background-color: transparent; /* 设置为透明背景色 */
    //   }
    // }
  }

  .plan-footer {
    height: 60px;
    margin-top: 50px;
    .choose {
      border: 1px solid #33AB4F;
      color: #33AB4F;
      width: fit-content;
      max-width: 200px;
      height: 16px;
      line-height: 16px;
      padding: 10px 8px;
      text-align: center;
      border-radius: 5px;
      margin: 0 auto;
      cursor: pointer;
      transition: all .3s;
      user-select: none;
    }
    // .choose:hover {
    //   background: #33AB4F;
    //   color: #fff;
    // }
    .no-choose {
      cursor: no-drop;
      background: #33AB4F;
      color: #fff;
    }
    .no-drop {
      cursor: no-drop;
    }
    // .no-choose:hover {
    //   color: #33AB4F;
    //   background: none;
    // }
  }
}
</style>
